// Central list of admin-panel pages that can be individually granted to
// a custom staff Role. Keys must match what Sidebar.jsx and ProtectedRoute
// check against — don't rename an existing key without updating both.
export const ADMIN_PERMISSIONS = [
    { key: "dashboard", label: "Dashboard" },
    { key: "orders", label: "Orders" },
    { key: "products", label: "Products (incl. Add Product)" },
    { key: "categories", label: "Categories" },
    { key: "brands", label: "Brands" },
    { key: "reviews", label: "Reviews" },
    { key: "siteContent", label: "Site Content" },
    { key: "bannerSlides", label: "Banner Slides" },
    { key: "promoCards", label: "Promo Cards" },
    { key: "trustPromos", label: "Trust Promos" },
    { key: "productSections", label: "Product Sections" },
    { key: "header", label: "Header" },
    { key: "footer", label: "Footer" },
    { key: "offers", label: "Offers" },
    { key: "promoCodes", label: "Promo Codes" },
    { key: "shippingAreas", label: "Shipping Areas" },
    { key: "drivers", label: "Drivers" },
    { key: "vehicles", label: "Vehicles" },
    { key: "notifications", label: "Notifications" },
    { key: "pages", label: "Pages" },
    { key: "splashScreen", label: "Splash Screens" },
    { key: "inventoryLog", label: "Inventory Log" },
    // "View" = can see the wallet table and every customer's ledger.
    // "Edit" = can also manually add cash to a customer's wallet.
    { key: "wallet", label: "1313 Wallet (Ledger & Manage Cash)" },
    { key: "vendors", label: "Vendor Panel (Stores, Vendors, Allocations)" },
];